import { DescribedImage, Event, Exhibitor, Hall, Post, Product } from '@planone/bau365/util-fair-data';

export interface ExhibitorResponse {
  cursors: {
    prev?: string;
    next?: string;
  };
  items: Exhibitor[];
}

export interface ExhibitorProductsResponse {
  cursors: {
    prev?: string;
    next?: string;
  };
  items: Product[];
}

export interface ExhibitorPostsResponse {
  cursors: {
    prev?: string;
    next?: string;
  };
  items: Post[];
}

export interface ExhibitorEventsResponse {
  cursors: {
    prev?: string;
    next?: string;
  };
  items: Event[];
}

export interface AlphabeticalExhibitorGrouping {
  [letter: string]: ExhibitorDirectoryEntry[];
}

export interface ExhibitorDirectoryEntry {
  fair_id: string;
  exhibitor_id: string;
  exhibitor_name?: string;
  exhibitor_is_main?: boolean;
  type: string;
  name: string;
  logo?: DescribedImage;
  exhibition_halls?: Hall[];
  is_highlighted?: boolean;
  has_ad?: boolean;
}

export interface KeyedExhibitorList {
  [name: string]: Exhibitor;
}

export interface ExhibitorListRequest {
  limit?: number;
  cursor?: string;
  fair_id?: string;
}

export interface CoExhibitorListRequest {
  exhibitor_id: string;
}

export interface ExhibitorDirectoryStatus {
  first: boolean;
  all: boolean;
  failed: boolean;
  loaded: {
    letters: string[];
    halls: string[];
    availableHalls: string[];
    availableLetters: string[];
    searchTerms: string[];
  };
  searchStatus?: ExhibitorDirectorySearchStatus;
}

export interface ExhibitorDirectorySearchStatus {
  searchTerm?: string;
  count?: number;
  loadedResults: number;
}

export interface ExhibitorSearchFilters {
  searchType?: ExhibitorSearchType[];
  searchTerm?: string;
  page?: string;
  searchSort?: ExhibitorSearchSortOrder;
  stringFilter?: ExhibitorSearchStringFilter[];
}

export enum ExhibitorSearchType {
  exhibitor = 'EXHIBITOR',
  brand = 'BRAND',
}

export enum ExhibitorSearchSortOrder {
  recommended = 'RECOMMENDED_DESC',
  alphabeticalAsc = 'ALPHABETICAL_ASC',
  alphabeticalDesc = 'ALPHABETICAL_DESC',
  dateAsc = 'DATE_ASC',
  dateDesc = 'DATE_DESC',
}

export type CombinedSearchResult = ExhibitorSearchResult | BrandSearchResult;
export type CombinedSearchResultItem = ExhibitorSearchResultItem | BrandSearchResultItem;

export enum ExhibitorSearchResultFlags {
  startup = 'STARTUP',
  highlight = 'HIGHLIGHT',
  topOfTheList = 'TOP_OF_THE_LIST',
}

export type ExhibitorSearchResultItem = BaseSearchResult & {
  flags: ExhibitorSearchResultFlags[];
};

export interface ExhibitorSearchResult {
  type: 'EXHIBITOR';
  exhibitor: ExhibitorSearchResultItem;
}

export type BrandSearchResultItem = BaseSearchResult & {
  exhibitor?: BrandSearchResultExhibitorReference;
};

export interface BrandSearchResult {
  type: 'BRAND';
  brand: BrandSearchResultItem;
}

export interface BaseSearchResult {
  short_description?: string;
  id: string;
  name: string;
  image: ExhibitorSearchResultImage;
  top_of_the_list: boolean;
  highlight: boolean;
  published_at?: Date;
  booth?: ExhibitorSearchResultBooth;
}

export interface BrandSearchResultExhibitorReference {
  type: 'EXHIBITOR';
  id: string;
  name?: string;
  image?: ExhibitorSearchResultImage;
}

export interface ExhibitorSearchResultBooth {
  fair_id?: string;
  hall_id?: string;
  hall_name: string;
  id?: string;
  name: string;
  exhibitor_type: ExhibitorSearchResultBoothType;
}

export enum ExhibitorSearchResultBoothType {
  ha = 'HA',
  ma = 'MA',
}

interface ExhibitorSearchResultImage {
  resource: string;
  provider: string;
}

export interface ExhibitorSearchStringFilter {
  name: string;
  filters: string[];
}

export interface ExhibitorSearchResultAdress {
  street?: string;
  house_number?: string;
  zip_code?: string;
  city?: string;
  country?: string;
}

export interface Facet {
  name: string;
  types: FacetType[];
}

export interface FacetType {
  name: string;
  count: number;
}
